// Toggle the popup form open and close
export default function popupOpen() {
    const popupTriggerButtons = document.querySelectorAll('.js-popup-trigger');
    const popupSuccessCloseButtons = document.querySelectorAll('.js-success-close');
    popupTriggerButtons.forEach(function(popupButton) {
        popupButton.addEventListener('click', function(e) {
            e.preventDefault();
            let eventName = popupButton.dataset.eventName;
            if (typeof eventName !== 'undefined') {
                window.eventName = eventName;
            } else {
                window.eventName = '';
            }
            document.body.classList.toggle('popup-form-open');
        });
    });
    popupSuccessCloseButtons.forEach(function(popupButtonClose) {
        popupButtonClose.addEventListener('click', function(e) {
            e.preventDefault();
            document.body.classList.remove('popup-success-open');
        });
    });
}
